import { RandomToken } from '@sibevin/random-token'

export default {
	methods: {
		randomString () {
			return RandomToken.gen({
				length: 16
			})
		}
	}
}
